import { ComparisonPageTemplate } from "@/components/ComparisonPageTemplate";
import { Brain, Users, Clock } from "lucide-react";

const CSWvsKahoot = () => {
  return (
    <ComparisonPageTemplate
      platformName="Kahoot!"
      platformUrl="https://kahoot.com"
      seoDescription="Compare CSW and Kahoot! learning platforms. Discover why CSW offers deeper learning beyond quizzes with flashcards."
      seoKeywords="CSW vs Kahoot, Kahoot alternative, free quiz maker, game-based learning"
      canonicalUrl="https://csw.live/flash-cards/csw-vs-kahoot/"
      heroDescription="Looking for more than game quizzes? CSW offers flashcards, collaborative study, and deeper learning experiences."
      alternativeDescription="While Kahoot excels at live quiz competitions, CSW provides a complete study ecosystem with flashcards."
      background="Kahoot! is a game-based learning platform popular in classrooms with live competitions and detailed analytics."
      pros={[
        { text: "Fun, game-based format" },
        { text: "Live classroom competitions" },
        { text: "Engaging for groups" }
      ]}
      cons={[
        { text: "Mostly multiple-choice format" },
        { text: "Some features require paid plans" },
        { text: "Not designed for individual study" }
      ]}
      cswFeatures={[
        { text: "Comprehensive Flashcards", available: true },
        { text: "Collaborative Study", available: true },
        { text: "Individual & Group Study", available: true },
        { text: "Free Access", available: true }
      ]}
      competitorFeatures={[
        { text: "Comprehensive Flashcards", available: false },
        { text: "Collaborative Study", available: true },
        { text: "Individual & Group Study", available: false },
        { text: "Free Access", available: false }
      ]}
      benefits={[
        { icon: Brain, title: "Complete Learning", description: "Flashcards and quizzes for comprehensive understanding." },
        { icon: Users, title: "Flexible Study Modes", description: "Study alone or with groups." },
        { icon: Clock, title: "Free & Unlimited", description: "Access all features without fees." }
      ]}
      forStudentsText="CSW goes beyond Kahoot's quiz games with comprehensive flashcards and flexible study modes."
      pricingText="Kahoot requires paid plans for advanced features. CSW provides complete capabilities free."
      competitorPrice="$17-$59/month"
    />
  );
};

export default CSWvsKahoot;
